package studio.goodegg.capsule

import kotlinx.serialization.Serializable

@Serializable
data class Category(
    val label: String,
    val genreId: String,
)
